import React, { useState } from "react";
import loader from "../assets/loader.gif";

export const Loading = () => {
  return (
    <>
      <div className="try-load">
        <img src={loader} />
      </div>
    </>
  );
};
